import { RecoverabilityIndex } from "@/components/RecoverabilityIndex/recoverabilityIndex";

import { useProductPageContext } from "../../context/productPage.context";

export const ProductPageRecoverabilityIndexContainer = () => {
    const { recoverabilityIndex } = useProductPageContext();

    if (!recoverabilityIndex) {
        return null;
    }

    return <RecoverabilityIndex recoverabilityIndex={recoverabilityIndex} />;
};
